import { PureComputed } from '@devexpress/dx-core';
import { TABLE_DATA_TYPE, TABLE_NODATA_TYPE } from './constants';
import { getColumnExtension } from '../../utils/column-extension';
import { GridColumnExtension, GetCellColSpanFn } from './../../types/table.types';
import { Row, GetRowIdFn } from '../../types';

export const tableColumnsWithDataRows: PureComputed<[any[], GridColumnExtension[]]> = (
  columns, columnExtensions,
) => columns.map((column) => {
  const { name } = column;
  const columnExtension = getColumnExtension(columnExtensions as GridColumnExtension[], name);
  return {
    column,
    key: `${TABLE_DATA_TYPE.toString()}_${name}`,
    type: TABLE_DATA_TYPE,
    width: columnExtension.width,
    align: columnExtension.align,
    wordWrapEnabled: columnExtension.wordWrapEnabled,
  };
});

export const tableRowsWithDataRows: PureComputed<[Row[], GetRowIdFn]> = (rows, getRowId) => (
  !rows.length
    ? [{ key: TABLE_NODATA_TYPE.toString(), type: TABLE_NODATA_TYPE }]
    : rows.map((row) => {
      const rowId = getRowId(row);
      return {
        row,
        rowId,
        type: TABLE_DATA_TYPE,
        key: `${TABLE_DATA_TYPE.toString()}_${rowId}`,
      };
    }));

export const tableCellColSpanGetter: GetCellColSpanFn = (params) => {
  const { tableRow, tableColumns, tableColumn } = params;
  if (tableRow.type === TABLE_NODATA_TYPE && tableColumns.indexOf(tableColumn) === 0) {
    return tableColumns.length;
  }
  return 1;
};
